import React from 'react'
import GameContainer from '../containers/GameContainer'

import '../App.css'

const App = () => (
	<div>
		<GameContainer />
	</div>
)

export default App



// WEBPACK FOOTER //
// ./src/components/App.js